<app-user-message *ngIf="loadError" type="error" [title]="'ACTION_NEEDED' | translate"
  [message]="'CHECK_YOUR_CONNECTION_AND_TRY_AGAIN' | translate" [actionLabel]="'TRY_AGAIN' | translate"
  [dismissible]="false" (action)="ngOnInit()"></app-user-message>
<div class="row" *ngIf="isLoading == false && !loadError">
  <div class="col-12 order-2 order-lg-1" [class.col-lg-9]="hidePicture == true" [class.text-right]="globalService.isRTL == true" [class.SmallArabicFont]="globalService.isRTL == true">
    <h5 class="mb-4 formSectionHeader">
      {{ globalService.Get("BASICINFORMATION") }}
    </h5>
    <div class="row">
      <div class="form-group col-6">
        <label for="firstName">{{ globalService.Get("FIRSTNAME") }}</label>
        <input type="text" class="form-control" name="firstName" ngModel required #firstName="ngModel" readonly
          [ngModel]="member.firstName" />
      </div>
      <div class="form-group col-6">
        <label for="lastName">{{ globalService.Get("LASTNAME") }}</label>
        <input type="text" class="form-control" name="lastName" ngModel required #lastName="ngModel" readonly
          [ngModel]="member.lastName" />
      </div>
    </div>
    <div class="row" *ngIf="isNumeric == true">
      <div class="form-group col-6">
        <label for="dateOfBirth">{{ globalService.Get("DOB") }}</label>
        <input type="text" class="form-control" name="dateOfBirth" ngModel #dateOfBirth="ngModel" readonly
          [ngModel]="member.dateOfBirth ? (member.dateOfBirth | localizedDate: 'MM/dd') : 'Not provided'" />
      </div>
      <div class="form-group col-6"> 
        <label for="gender">{{ globalService.Get("GENDER") }}</label>
        <input type="text" class="form-control" name="gender" ngModel required #lastName="ngModel" readonly
          [ngModel]="member.gender == true ? 'Female' : 'Male'" />
      </div>
    </div>
    <div class="row" *ngIf="isNumeric == false">
      <div class="form-group col-6">
        <label for="emailAddress">{{ globalService.Get("EMAIL") }}</label>
        <input type="text" class="form-control" name="emailAddress" ngModel required #emailAddress="ngModel" readonly
          [ngModel]="member.emailAddress" />
      </div>
      <div class="form-group col-6">
        <label for="phoneNumber">{{ globalService.Get("CELLPHONE") }}</label>
        <input type="text" class="form-control" name="phoneNumber" ngModel required #phoneNumber="ngModel" readonly
          [ngModel]="member.phoneNumber" />
      </div>
    </div>    
  </div> 
  <div class="col-12 order-1 order-lg-2 col-lg-3 mt-4" *ngIf="hidePicture == true">
    <div class="form-group text-center mt-lg-4">
      <img [src]="member.pictureUrl" class="profileImage mb-2" /><br />
    </div>
  </div>
</div>